import { AreaOfExpertise } from './types/user';

export const externalLinks = {
  footer: {
    shortcuts: {
      about: 'https://www.enova.no/energimerking/',
      guide: 'https://www.enova.no/energimerking/bolig/',
      subsidies: 'https://www.enova.no/privat/alle-energitiltak/'
    },
    help: {
      privacyAndCookies: 'https://www.enova.no/nb/om-oss/hvem-er-enova/prinsipper-etterlevelse/datahandtering/cookies/',
      siteMap: 'mailto:nettredaktor@enova.no'
    },
    contact: {
      kontaktoss: 'https://www.enova.no/om-enova/kontakt-oss/'
    }
  },

  profile: {
    [AreaOfExpertise.ENERGIRADGIVER]: 'https://www.enova.no/privat/alle-energitiltak/energiradgivning/'
  }
};
